package link.erpango.quip.utils

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLAnchorElement

class JsPlatformManager : IPlatformManager {
    override fun shareJsonData(jsonData: String) {
        val blob = js("new Blob([jsonData], {type: 'application/json'})")
        val url = js("URL.createObjectURL(blob)") as String

        val anchor = document.createElement("a") as HTMLAnchorElement
        anchor.href = url
        anchor.download = "data.json"
        document.body?.appendChild(anchor)
        anchor.click()
        document.body?.removeChild(anchor)
        js("URL.revokeObjectURL(url)")
    }

    override fun openFile(filePath: String, mimeType: String) {
        // filePath is a blob: URL from saveBase64ToFile — opens in new tab
        window.open(filePath, "_blank")
    }

    override fun shareFile(filePath: String, mimeType: String) {
        // Get the original filename from JsFileUtils
        val fileName = JsBlobRegistry.getFileName(filePath)

        val anchor = document.createElement("a") as HTMLAnchorElement
        anchor.href = filePath
        anchor.download = fileName
        document.body?.appendChild(anchor)
        anchor.click()
        document.body?.removeChild(anchor)
    }

    override fun vibrate(soft: Boolean, duration: Long) {
        if (soft) {
            window.navigator.vibrate(intArrayOf(20))
        } else {
            window.navigator.vibrate(intArrayOf(duration.toInt()))
        }
    }

    override fun copyToClipboard(text: String) {
        js("navigator.clipboard.writeText(text)")
    }
}
